import React from "react";

export const EditCard = ({ children }) => {
  return (
    <div className="col-span-1 edit-bg p-3">
      <div className="col-span-1 w-full h-full edit-bg2"></div>
      {children}
    </div>
  );
};
